var exports = {
  "KE": "VoiceSceneToolbar.module__toolbar___Tnd5Yz",
  "uW": "VoiceSceneToolbar.module__section___Tnd5Yz",
  "_V": "VoiceSceneToolbar.module__dock___Tnd5Yz",
  "gO": "VoiceSceneToolbar.module__toggles___Tnd5Yz",
  "MH": "VoiceSceneToolbar.module__frameRate___Tnd5Yz",
  "Ap": "VoiceSceneToolbar.module__frameRateSelect___Tnd5Yz",
  "id": "VoiceSceneToolbar.module__qualitySelect___Tnd5Yz",
  "L$": "VoiceSceneToolbar.module__toggle___Tnd5Yz",
  "_s": "VoiceSceneToolbar.module__toggleOn___Tnd5Yz",
  "Kk": "VoiceSceneToolbar.module__icon___Tnd5Yz",
  "Pf": "VoiceSceneToolbar.module__label___Tnd5Yz",
  "Qx": "VoiceSceneToolbar.module__liteHint___Tnd5Yz",
  "Tm": "VoiceSceneToolbar.module__reply___Tnd5Yz",
  "E_": "VoiceSceneToolbar.module__bottomRow___Tnd5Yz",
  "e7": "VoiceSceneToolbar.module__iconOnly___Tnd5Yz",
  "Gy": "VoiceSceneToolbar.module__mark___Tnd5Yz",
  "sM": "VoiceSceneToolbar.module__srOnly___Tnd5Yz",
};

module.exports = exports;
